export function formatINR(value) {
  const v = Number(value) || 0;
  if (v >= 10000000) return `₹${(v / 10000000).toFixed(2)} Cr`;
  if (v >= 100000) return `₹${(v / 100000).toFixed(2)} L`;
  if (v >= 1000) return `₹${(v / 1000).toFixed(1)}K`;
  return `₹${v.toLocaleString("en-IN")}`;
}

export function formatFullINR(value) {
  return `₹${(Number(value) || 0).toLocaleString("en-IN")}`;
}

export const POTENTIAL_LABELS = {
  1: "Low",
  2: "Below Average",
  3: "Medium",
  4: "High",
  5: "Very High",
};

export const ROLE_LABELS = {
  super_admin: "Super Admin · Head Office",
  admin: "Branch Admin",
  manager: "Manager · Channel Partner",
};

export function initials(name) {
  if (!name) return "?";
  return name
    .split(" ")
    .map((n) => n[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();
}
